import { Link } from "react-router-dom";
import { useT } from "@reciperoll/core";
import { NotFoundView } from "../components/NotFoundView";

// Catch-all page for unknown routes. Rendered inside AppLayout so it keeps the
// nav chrome, letting the user get back on track without a dead end.
export default function NotFound() {
  const t = useT();
  return (
    <NotFoundView
      code="404"
      title={t("notFound.title")}
      message={t("notFound.message")}
      actions={
        <>
          <Link
            to="/"
            className="rounded-xl bg-terracotta hover:bg-terracotta-dark transition-colors px-5 py-2.5 text-sm font-bold text-white"
          >
            {t("notFound.backHome")}
          </Link>
          <Link
            to="/recipes"
            className="rounded-xl bg-surface-2 hover:bg-line transition-colors px-5 py-2.5 text-sm font-semibold text-ink-soft"
          >
            {t("recipe.browseRecipes")}
          </Link>
        </>
      }
    />
  );
}
